import React from 'react';

export interface TabConfig {
  key: string;
  label: string;
}

interface TabNavigationBarProps<T extends string> {
  activeTab: T;
  setActiveTab: (tab: T) => void;
  tabs: TabConfig[];
}

/**
 * Generic tab navigation bar component
 * Reusable across Partner Pricing, Planning (Buyers/Suppliers), and other tabbed interfaces
 * Provides flexible tab switching with customizable tab configurations
 */
function TabNavigationBar<T extends string>({
  activeTab,
  setActiveTab,
  tabs,
}: TabNavigationBarProps<T>) {
  return (
    <div className="flex items-center gap-1">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key as T)}
          className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-all duration-200 ${
            activeTab === tab.key
              ? "bg-white text-gray-800 shadow-md"
              : "bg-white/20 text-white hover:bg-white/30"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default TabNavigationBar;
